/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type ComposedProps = Props & WithI18nProps;

class WarningUpgradeBanner extends Component<ComposedProps> {
  render() {
    const { i18n, switchMerchandisingV2, migrateNewFeatureV2, migrateStatus } = this.props;

    return (
      <Banner
        title={i18n.translate(
          'AdminHTML.Merchandising.UpgradeVersionMerchandisingModal.upgradeWarningTitle'
        )}
        status="warning"
        action={{
          content: i18n.translate(
            'AdminHTML.Merchandising.UpgradeVersionMerchandisingModal.upgradeNow'
          ),
          loading: migrateStatus === 'running',
          onAction: () => migrateNewFeatureV2()
        }}
        secondaryAction={{
          content: i18n.translate(
            'AdminHTML.Merchandising.UpgradeVersionMerchandisingModal.backActionLabel'
          ),
          onAction: () => {
            switchMerchandisingV2(false).then(() => {});
          }
        }}
      />
    );
  }
}

export default withI18n()(WarningUpgradeBanner);
